import React, { useEffect } from "react";
import { Switch, Route, RouteComponentProps } from "react-router-dom";
import { useApi } from "../../auth";
import "./portal.css";
import { Dashboard } from "../dashboard";
import { NavigationHeader } from "../../components/molecules/navigation-header/navigation-header";

interface PortalProps extends RouteComponentProps<{}>, React.Props<{}> {}

export const Portal: React.FunctionComponent<any> = ({
  match,
}: PortalProps) => {
  const { api } = useApi();

  useEffect(() => {
    api.getAuthenticatedData();
  }, [api]);

  return (
    <div className="Portal">
      <NavigationHeader
        signedIn={true}
        hideNavigation={window.location.href.includes("pdf")}
      />
      <main className="Portal-Main">
        <Switch>
          <Route exact path={`${match.url}`} component={Dashboard} />
        </Switch>
      </main>
    </div>
  );
};
